module.exports = __webpack_public_path__ + "static/media/mem-logo.ef5f6573.png";